<div class="space-y-4">
  <div class="space-y-2">
    <label class="block text-sm font-medium text-gray-700">Select Fields</label>
    <p-multiSelect
      [options]="fieldOptions"
      display="chip"
      optionLabel="label"
      optionValue="value"
      [(ngModel)]="selectedFields"
      placeholder="Choose one or more fields"
      class="w-full"
      [disabled]="processed"
      [showToggleAll]="false"
      [filter]="false"
    ></p-multiSelect>
  </div>

  <div class="space-y-1">
    <label class="block text-sm font-medium text-gray-700"> Comments </label>
    <!-- <textarea
      class="w-full rounded-md border border-gray-300 p-3 text-sm focus:border-gray-400 focus:outline-none resize-none"
      rows="4"
      placeholder="Add remarks or instructions..."
      [(ngModel)]="comment"
      [readonly]="processed || selectedFields.length === 0"
      [disabled]="processed || selectedFields.length === 0"
    ></textarea> -->
    <div
      pTooltip="{{
        processed || selectedFields.length === 0
          ? 'Please select at least one field to enable comments'
          : ''
      }}"
      tooltipPosition="top"
    >
      <textarea
        class="w-full rounded-md border border-gray-300 p-3 text-sm focus:border-gray-400 focus:outline-none resize-none"
        rows="4"
        placeholder="Add remarks or instructions..."
        [(ngModel)]="comment"
        [readonly]="processed || selectedFields.length === 0"
        [disabled]="processed || selectedFields.length === 0"
      ></textarea>
    </div>
  </div>

  <div class="flex flex-col gap-3">
    <label class="text-sm font-medium text-gray-700">Additional Flags</label>
    <div class="flex items-center gap-2">
      <p-checkbox
        [(ngModel)]="isEstimatedAdoptionDate"
        [binary]="true"
        inputId="estimatedAdoption"
        [disabled]="processed || !isAdoptionSelected"
      ></p-checkbox>
      <label for="estimatedAdoption" class="text-sm text-gray-700">
        is_estimated_adoption_date
      </label>
    </div>
    <div class="flex items-center gap-2">
      <p-checkbox
        [(ngModel)]="isEstimatedTerminationDate"
        [binary]="true"
        inputId="estimatedTermination"
        [disabled]="processed || !isTerminationSelected"
      ></p-checkbox>
      <label for="estimatedTermination" class="text-sm text-gray-700">
        is_estimated_termination_date
      </label>
    </div>
    <div class="flex items-center gap-2">
      <p-checkbox
        [(ngModel)]="isEstimatedAmendedDate"
        [binary]="true"
        inputId="estimatedAmendment"
        [disabled]="processed || !isAmendmentSelected"
      ></p-checkbox>
      <label for="estimatedAmendment" class="text-sm text-gray-700">
         is_estimated_amended_date
      </label>
    </div>
  </div>
</div>

<!-- Buttons -->
<div class="mt-6 flex justify-end space-x-3">
  <button
    class="px-4 py-2 text-gray-600 border border-gray-300 rounded-md hover:bg-gray-100"
    type="button"
    (click)="onCancel()"
  >
    Cancel
  </button>

  <button
    class="px-4 py-2 bg-black text-white rounded-md hover:bg-gray-800 disabled:bg-gray-400 disabled:cursor-not-allowed"
    type="button"
    (click)="onAdd()"
    *ngIf="!processed"
  >
    Add
  </button>
  <!-- <button
    class="px-4 py-2 bg-black text-white rounded-md hover:bg-gray-800 disabled:bg-gray-400 disabled:cursor-not-allowed"
    type="button"
    (click)="onAdd()"
    *ngIf="!processed"
    [disabled]="disableSave"
  >
    Add
  </button> -->
</div>
